module.exports = __webpack_public_path__ + "img/elementlengths_jasa.51f2efa6.png";